<template lang="pug">
v-app
  v-main(style="background-color:#DCEBFB")
    v-app-bar.custom-app-bar.cutom-app-bar(absolute flat dark height="150px" min-height="70px" shrink-on-scroll scroll-target='#scrolling-techniques-2', :style="appbarcss" v-if="$store.state.windowSize.w > 600")
      v-container.pa-0(style="max-width: 1300px;height:100%;")
        v-row(dense style="height: 100%;" v-if="scrolling>1")
          v-col(cols="12" style="oveflow:hidden;display: flex;align-items: center;justify-content: center;").mt-1
            div(style="border-radius:0px;overflow:hidden;padding:0px 0px;background-color:#FFF;transition: all 0.3s ease !important;").pt-0.pb-0.pr-1.pl-0
              v-img(src="https://sisep.minedu.gob.bo/img/logo-minedu-2025-horizontal-v2.jpg" max-width="150px" max-height="56px" style="transition: all 0.3s ease !important;")
            div(style="border-radius:6px;overflow:hidden;padding:0px 0px 0px 0px;transition: all 0.3s ease !important;")
              v-img(src="https://sisep.minedu.gob.bo/img/logo-uie.png" max-width="160px" style="transition: all 0.3s ease !important;")
        v-row(dense style="height: 100%;" v-else)
          v-col(cols="12" style="oveflow:hidden;display: flex;align-items: center;justify-content: center;").mt-2
            div(style="border-radius:6px;overflow:hidden;padding:0px 0px;background-color:#FFF;transition: all 0.3s ease !important;").pl-0.pr-2.pt-.pb-1
              v-img(src="https://sisep.minedu.gob.bo/img/logo-minedu-2025-horizontal-v2.jpg" max-width="280px" max-height="113px" style="transition: all 0.3s ease !important;")
            div(style="border-radius:6px;overflow:hidden;padding:0px 0px 0px 0px;transition: all 0.3s ease !important;padding-bottom:4px;")
              v-img(src="https://sisep.minedu.gob.bo/img/logo-uie.png" max-width="280px" height="50px" style="transition: all 0.3s ease !important;")
    v-app-bar.custom-app-bar.cutom-app-bar(absolute flat dark height="240" min-height="70" shrink-on-scroll scroll-target='#scrolling-techniques-2', :style="appbarcss" v-else)
      v-container.pa-0(style="max-width: 1300px;height:100%;")
        v-row(dense style="height: 100%;" v-if="scrolling>1")
          v-col(cols="12" style="oveflow:hidden;display: flex;flex-direction: column;align-items:center;justify-content: center;")
            div(style="border-radius:6px;overflow:hidden;padding:0px 0px;background-color:#FFF;transition: all 0.3s ease !important;display:none;")
              v-img(src="https://sisep.minedu.gob.bo/img/logo-minedu-2025-horizontal-v2.jpg" max-width="300px" style="transition: all 0.3s ease !important;")
            div(style="border-radius:6px;overflow:hidden;padding:10px 0px 0px 0px;transition: all 0.3s ease !important;")
              v-img(src="https://sisep.minedu.gob.bo/img/logo-uie.png" max-width="250px" height="40px" style="transition: all 0.3s ease !important;")
        v-row(dense style="height: 100%;" v-else)
          v-col(cols="12" style="oveflow:hidden;display: flex;flex-direction: column;align-items:center;justify-content: center;")
            div(style="border-radius:6px;overflow:hidden;padding:0px 0px;background-color:#FFF;transition: all 0.3s ease !important;").pl-2.pr-2
              v-img(src="https://sisep.minedu.gob.bo/img/logo-minedu-2025-horizontal-v2.jpg" max-width="250px" max-height="100" style="transition: all 0.3s ease !important;")
            div(style="border-radius:6px;overflow:hidden;padding:15px 0px 0px 0px;transition: all 0.3s ease !important;")
              v-img(src="https://sisep.minedu.gob.bo/img/logo-uie.png" max-width="250px" height="40px" style="transition: all 0.3s ease !important;")

    v-sheet#scrolling-techniques-2.overflow-y-auto(:style="customStyle" @scroll="handleScroll" class="scrollable-container")
      router-view
      v-footer(height="220px").mt-5.pa-0.custom-style-footer
        v-container.pa-0(style="max-width: 1300px")
          v-row(dense)
            v-col(cols="12" sm="6" md="4" lg="3").tabletoff
              v-card(flat).transparent
                v-card-text.pa-0|
                  h4.overline(style="color:#960407;") Enlaces de interés
                  ul.list-links
                    li(v-for="(item, index) in links.slice(0,6)" :key="'l1'+index")
                      a(:href="item.link" style="color:#333;") {{ item.title }}
            v-col(cols="12" sm="6" md="4" lg="3").tabletoff
              v-card.transparent(flat)
                v-card-text.pa-0
                  h4.overline(style="opacity:0") Enlaces de interés
                  ul.list-links
                    li(v-for="(item, index) in links.slice(6,12)" :key="'l2'+index")
                      a(:href="item.link" style="color:#333;") {{ item.title }}
            v-col(cols="12" sm="6" md="4" lg="3").tabletoff
              v-card.transparent(flat)
                v-card-text.pa-0
                  h4.overline(style="opacity:0") Enlaces de interés
                  ul.list-links
                    li(v-for="(item, index) in links.slice(12,18)" :key="'l3'+index")
                      a(:href="item.link" style="color:#333;") {{ item.title }}
            v-col(cols="12" md="12" lg="3")
              v-card.transparent(flat style="border-radius:15px !important;overflow:hidden !important;")
                v-card-text.mt-6
                  v-flex(style="width:270px;margin:0px auto;background-color:#FFF !important;border-radius:10px;").pt-2.pb-2
                    v-img(src="https://sisep.minedu.gob.bo/img/logo-uie.png" width="250px" height="40px").logotablet.ml-2
                  //-v-img(src="/img/logo-minedu-2021.png" width="320px").logotablet
</template>

<style lang="stylus">
.cutom-app-bar .v-toolbar__content
  margin 0px
  padding 0px
  /* background url('/assets/header-background.jpg') */
</style>

<style lang="stylus" scoped>

.custom-style-footer
  //background #385665 !important
  //background-image linear-gradient(rgb(35, 75, 104) 10%, rgb(30, 65, 94) 90%);
  //2025background-image linear-gradient(rgb(255, 255, 255) 10%, rgb(210, 210, 210) 90%);
  background #FFF
  //background #385665 !important
  overflow hidden
  border-top 7px solid #B1B1B1

.list-links
  list-style-position outside
  padding-left 10px

.list-links li
  list-style none

.list-links li a
  color #FFF
  text-decoration none

.list-links li:before
  content "·"
  font-size 60px
  vertical-align middle
  line-height 25px
  color #D5A022

.custom-app-bar
  border-radius 0px
  border-bottom 7px solid #B1B1B1
  //border-top 7px solid #1E2933
  background #FFF !important
  //background-image linear-gradient(rgb(30, 65, 94) 10%, rgb(43, 91, 132) 90%);
  //background-image linear-gradient(rgb(35, 75, 104) 10%, rgb(30, 65, 94) 90%) !important;
  //background #F00 !important
  //background-image url("/img/logo-horizontal.jpg") !important
  //background-repeat no-repeat !important
  //background-position center center !important
  //background-size 400px !important
  z-index 2

.newclass 
  color #FF7700

.activeTab
  background-image linear-gradient(#13191E 10%, #1F2A32 90%)

//.v-tab--active
//  color #FFF !important

//.v-tabs-slider-wrapper
//  bottom 0 !important
//  top 0 !important

.bannerPanel
  padding 50px

.logotablet
  margin 0px

@media screen and (max-width: 450px)
  .custom-app-bar
    background-size 300px !important

@media screen and (max-width: 1263px)
  .bannerPanel
    padding 0px

@media screen and (max-width: 1335px)
  .tabletoff
    display none
  .logotablet
    margin 0px auto
</style>


<script>
export default {
  data(){return{
    links: [
      {link:"http://www.presidencia.gob.bo/", title: "Presidencia"},
      {link:"http://www.mingobierno.gob.bo/", title: "Gobierno"},
      {link:"https://www.mintrabajo.gob.bo/", title: "Trabajo, Empleo y Previsión Social"},
      {link:"https://www.economiayfinanzas.gob.bo/", title: "Economía y Finanzas Públicas"},
      {link:"http://www.comunicacion.gob.bo/", title: "Comunicación"},
      {link:"http://www.cancilleria.gob.bo/webmre/", title: "Relaciones Exteriores"},
      {link:"http://www.mindef.gob.bo/mindef/", title: "Defensa"},
      {link:"http://www.planificacion.gob.bo/index", title: "Planificación del Desarrollo"},
      {link:"https://www.hidrocarburos.gob.bo/", title: "Hidrocarburos"},
      {link:"http://produccion.gob.bo/",title:"Desarrollo Productivo y Economía Plural"},
      {link:"https://www.oopp.gob.bo/",title:"Obras Públicas Servicios y Vivienda"},
      {link:"http://www.mineria.gob.bo/",title:"Minería y Metalurgia"},
      {link:"https://www.justicia.gob.bo/portal/index.php",title:"Justicia y Transparencia Institucional"},
      {link:"https://www.minsalud.gob.bo/",title:"Salud"},
      {link:"http://www.mmaya.gob.bo/",title:"Medio Ambiente y Agua"},
      {link:"http://www.ruralytierras.gob.bo/",title:"Desarrollo Rural y Tierras"},
      {link:"http://www.minculturas.gob.bo/",title:"Culturas y Turismo"},
      {link:"https://www.minenergias.gob.bo/",title:"Energías"},
    ],
    alerta: false,
    mensaje: '',
    scrolling: 0,
  }},
  computed:{
    appbarcss(){
      if(this.scrolling>50){
        return "overflow:hidden;background-image:none !important"
      }
      else{
        return "overflow:hidden;background:#FFF url('https://sisep.minedu.gob.bo/img/header-background.jpg') no-repeat center center !important;"
      }
    },
    istop(){
      //float:left;display:inline;background-color:#F00;width:20px;height:20px;
      return "44"
    },
    customStyle(){
      if(this.$store.state.windowSize.w>450){
        return "padding-top:20px;height:" + (this.$store.state.windowSize.h) + "px;overflow:hidden;background-color:#DDD;"
      }
      else{
        return "margin-top:47px;height:" + (this.$store.state.windowSize.h) + "px;overflow:hidden;background-color:#DDD"
      }

      /*return (
        "height:" + (this.$store.state.windowSize.h) + "px;overflow:hidden;background-color:#DDD"
      );*/
    },
    minHCustom(){
      return (this.$store.state.windowSize.w>450)? 72: 55
    },
    hCustom(){
      return (this.$store.state.windowSize.w>450)? 172 : 125
    },
    hLogo(){
      return (this.$store.state.windowSize.w>450)? 440 : 320
    },
    hUgpsep(){
      return (this.$store.state.windowSize.w>600)? "500px" : "400px"
    }
  },
  mounted(){
    this.initializeAutoGetMessagesInit();
  },
  methods:{
    handleScroll(event){
      this.scrolling = event.target.scrollTop;
    },
    async initializeAutoGetMessagesInit(){
       try {
        let ran = Math.floor(Math.random() * (999999 - 1 + 1) + 1);
        let url = "https://sisep.minedu.gob.bo/info/sisep-info";
        //let url = "http://100.0.102.26:8103/sisep-info";
        let resp = await axios.get(url+"?ver="+ran.toString());
        if(resp.data.alerta == true){
          this.alerta = true;
          this.mensaje = resp.data.mensaje;
        }
        if(resp.data.mantenimiento == true){
            this.$store.state.isInMaintenance = true;
        }
        else{
          this.$store.state.isInMaintenance = false;
        }
        /*if(resp.data.version !== document.title.substr(document.title.length - 5)){
          this.alertVersion = true;
          this.$store.state.version = resp.data.version;
        }
        else{
          this.alertVersion = false
        }*/
      } catch (error) {
        this.$store.state.isInMaintenance = false;
        this.alerta = false;
        //this.$snotify.success(error);
        //this.alertVersion = false
      }
    },
    async initializeAutoGetMessages(){
      setInterval(async function(){
        try {
          let ran = Math.floor(Math.random() * (999999 - 1 + 1) + 1);
          let url = "https://sisep.minedu.gob.bo/info/sisep-info";
          //let url = "http://100.0.102.26:8103/sisep-info";
          let resp = await axios.get(url+"?ver="+ran.toString());
          if(resp.data.alerta == true){
            this.alerta = true;
            this.mensaje = resp.data.mensaje;
          }
          if(resp.data.mantenimiento == true){
            this.$store.state.isInMaintenance = true;
          }
          else{
            this.$store.state.isInMaintenance = false;
          }
          /*if(resp.data.version !== document.title.substr(document.title.length - 5)){
            this.alertVersion = true;
            this.$store.state.version = resp.data.version;
          }
          else{
            this.alertVersion = false
          }*/
        } catch (error) {
          //this.$snotify.success(error);
          //this.alertVersion = false
          this.$store.state.isInMaintenance = false;
          this.alerta = false;
        }
      //}.bind(this),300000);// 5 minutos
      }.bind(this),600000);// 10 minutos
    }
  },
  created(){
    this.initializeAutoGetMessages();
  }
}
</script>